<template>
  <div class="nsb" :class="{ 'nsb--collapsed': collapsed }">

    <!-- Header / Logo + toggle (always top — same spot expanded/collapsed) -->
    <div class="nsb__header">
      <router-link v-if="!collapsed" class="nsb__logo" to="/programs" @click.native="onLogoClick">
        <img src="@/assets/logo.svg" alt="MentorMe" />
      </router-link>
      <div v-else class="nsb__logo-mini" @click="toggleSidebar">M</div>

      <button
        type="button"
        class="nsb__toggle-btn"
        :class="{ 'nsb__toggle-btn--expand': collapsed }"
        @click="toggleSidebar"
        :title="collapsed ? 'Развернуть меню' : 'Свернуть меню'"
        :aria-label="collapsed ? 'Развернуть боковую панель' : 'Свернуть боковую панель'"
      >
        <svg v-if="!collapsed" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <polyline points="15 18 9 12 15 6" />
        </svg>
        <svg v-else width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <polyline points="9 18 15 12 9 6" />
        </svg>
        <span v-if="collapsed" class="nsb__toggle-label"></span>
      </button>
    </div>

    <div class="nsb__body">
    <!-- Nav -->
    <nav class="nsb__nav">
      <p v-if="!collapsed" class="nsb__section-label">Основное</p>

      <!-- user / guest -->
      <template v-if="$store.state.role === 'user' || $store.state.role === 'guest'">
        <div
          v-for="item in visibleUserTabs"
          :key="item.route"
          class="nsb__item"
          :class="{ 'nsb__item--active': $route.path === item.route || $route.path === item.route1 }"
          @click="guestRouteFilter(item.route)"
          :title="collapsed ? item.name : ''"
        >
          <img :src="require('@/assets/icons/' + item.img + '.svg')" class="nsb__item-icon" />
          <span v-if="!collapsed" class="nsb__item-label">{{ item.name }}</span>

          <!-- Значок непрочитанного. В свёрнутом меню — точкой: число рядом с
               одной иконкой не читается, а знать «что-то пришло» нужно. -->
          <span
            v-if="item.badge === 'messenger' && unreadMessages > 0"
            class="nsb__badge"
            :class="{ 'nsb__badge--dot': collapsed }"
            :title="collapsed ? 'Непрочитанные сообщения' : ''"
          >{{ collapsed ? '' : unreadBadge }}</span>
        </div>
      </template>

      <!-- curator -->
      <template v-if="$store.state.role === 'curator'">
        <div
          v-for="(item, i) in tabsCurator"
          :key="i"
          class="nsb__item"
          :class="{ 'nsb__item--active nsb__item--active-curator': $route.path === item.route || $route.path === item.route1 }"
          @click="$router.push(item.route)"
          :title="collapsed ? item.name : ''"
        >
          <img :src="require('@/assets/icons/' + item.img + '.svg')" class="nsb__item-icon" />
          <span v-if="!collapsed" class="nsb__item-label">{{ item.name }}</span>
        </div>
      </template>

      <!-- expert -->
      <template v-if="$store.state.role === 'expert'">
        <div
          v-for="(item, i) in tabsExpert"
          :key="i"
          class="nsb__item"
          :class="{ 'nsb__item--active nsb__item--active-curator': $route.path === item.route || $route.path === item.route1 }"
          @click="$router.push(item.route)"
          :title="collapsed ? item.name : ''"
        >
          <img :src="require('@/assets/icons/' + item.img + '.svg')" class="nsb__item-icon" />
          <span v-if="!collapsed" class="nsb__item-label">{{ item.name }}</span>
        </div>
      </template>

      <!-- supervisor -->
      <template v-if="$store.state.role === 'supervisor'">
        <div
          v-for="vis in tabsSupervisor"
          :key="vis.route"
          class="nsb__item"
          :class="{ 'nsb__item--active nsb__item--active-visor': $route.path === vis.route || $route.path === vis.route1 }"
          @click="$router.push(vis.route)"
          :title="collapsed ? vis.name : ''"
        >
          <img :src="require('@/assets/icons/' + vis.img + '.svg')" class="nsb__item-icon" />
          <span v-if="!collapsed" class="nsb__item-label">{{ vis.name }}</span>
        </div>
      </template>

      <!-- chief -->
      <template v-if="$store.state.role === 'chief'">
        <div
          v-for="vis in tabsChief"
          :key="vis.route"
          class="nsb__item"
          :class="{ 'nsb__item--active nsb__item--active-visor': $route.path === vis.route || $route.path === vis.route1 }"
          @click="$router.push(vis.route)"
          :title="collapsed ? vis.name : ''"
        >
          <img :src="require('@/assets/icons/' + vis.img + '.svg')" class="nsb__item-icon" />
          <span v-if="!collapsed" class="nsb__item-label">{{ vis.name }}</span>
        </div>
      </template>
    </nav>

    <!-- News (user, expanded only) -->
    <div class="nsb__news" v-if="$store.state.role === 'user' && !collapsed && news.length">
      <p class="nsb__section-label">Новости</p>
      <a
        v-for="item in news"
        :key="item.id || item.title"
        :href="item?.link"
        target="_blank"
        class="nsb__news-item"
      >
        <img :src="item.image" v-if="item.image" />
        <span>{{ item.title }}</span>
      </a>
    </div>
    </div>
  </div>

  <teleport to="body">
    <GuestModal v-show="$store.state.isBlocked" @close="toggleBlock(false)" />
  </teleport>
</template>

<script>
import { mapActions } from 'vuex';
import axios from "axios";
import GuestModal from '@/components/guest/modal.vue';

export default {
  components: { GuestModal },
  data() {
    return {
      tabsSupervisor: [
        { img: 'tab_1',  name: 'Личный кабинет',  route: '/supervisor' },
        { img: 'tabc_3', name: 'Пользователи',    route: '/supervisor/users' },
        { img: 'tab_8',  name: 'Платформа',        route: '/supervisor/platform' },
        { img: 'tabc_4', name: 'Уведомления',     route: '/curator/notifications' },
      ],
      tabsChief: [
        { img: 'tab_1',  name: 'Личный кабинет',  route: '/supervisor' },
        { img: 'tabc_3', name: 'Пользователи',    route: '/supervisor/users' },
        { img: 'wait',   name: 'Заявки',           route: '/chief/requests' },
        { img: 'tab_8',  name: 'Платформа',        route: '/supervisor/platform' },
        { img: 'tabc_4', name: 'Уведомления',     route: '/curator/notifications' },
      ],
      tabsCurator: [
        { img: 'tab_1',  name: 'Личный кабинет',  route: '/curator' },
        { img: 'tabc_2', name: 'Программы',        route: '/curator/programs' },
        { img: 'tabc_3', name: 'Пользователи',    route: '/curator/users' },
        { img: 'tabc_4', name: 'Уведомления',     route: '/curator/notifications' },
      ],
      tabsExpert: [
        { img: 'tab_1',  name: 'Личный кабинет',  route: '/curator' },
        { img: 'tabc_2', name: 'Программы',        route: '/curator/programs' },
        { img: 'wait',   name: 'Заявки',           route: '/expert/requests' },
        { img: 'tabc_3', name: 'Пользователи',    route: '/curator/users' },
        { img: 'tabc_4', name: 'Уведомления',     route: '/curator/notifications' },
      ],
      tabs: [
        { img: 'tab_1', name: 'Личный кабинет',        route: '/platform',           requiresApprovedPrograms: true },
        { img: 'tab_2', name: 'Поиск программ',         route: '/programs',           route1: '/programs/1' },
        { img: 'tab_3', name: 'Избранное',              route: '/favourites' },
        { img: 'tab_4', name: 'Поступление',            route: '/platform/admission' },
        { img: 'tab_10', name: 'Сообщения',              route: '/platform/messages', badge: 'messenger', usersOnly: true },
        { img: 'tab_5', name: 'Международные гранты',   route: '/platform/intGrants' },
        { img: 'tab_6', name: 'Языковая и тест. школа', route: '/platform/schools' },
        { img: 'tab_9', name: 'Премиум опции',           route: '/platform/premium' },
        { img: 'tab_7', name: 'Полезное',               route: '/platform/useful' },
      ],
      news: [],
    };
  },
  computed: {
    collapsed() {
      return this.$store.state.sidebarCollapsed;
    },
    unreadMessages() {
      return this.$store.state.messenger?.unread || 0;
    },
    /** Больше сотни показываем как «99+»: точное число там уже ничего не решает. */
    unreadBadge() {
      return this.unreadMessages > 99 ? '99+' : String(this.unreadMessages);
    },
    visibleUserTabs() {
      return this.tabs.filter((tab) => {
        if (tab.hidden) return false;
        // Гостю переписка не положена: куратора у него нет, а маршрут для его
        // роли закрыт — пункт вёл бы либо в окно «оформите доступ», либо (по
        // прямой ссылке) на страницу входа, хотя человек уже вошёл.
        if (tab.usersOnly && this.$store.state.role !== 'user') return false;
        if (
          tab.requiresApprovedPrograms &&
          this.$store.state.role === 'user' &&
          !this.$store.state.hasApprovedPrograms
        ) return false;
        return true;
      });
    },
  },
  mounted() {
    // Значок нужен на любой странице кабинета, поэтому слежение живёт в меню:
    // оно смонтировано всегда, пока человек внутри платформы.
    if (this.$store.state.role === 'user') this.$store.dispatch('messenger/watch');
  },

  beforeUnmount() {
    this.$store.dispatch('messenger/unwatch');
  },

  methods: {
    ...mapActions(['toggleBlock']),
    toggleSidebar() {
      this.$store.dispatch('toggleSidebar');
    },
    onLogoClick() {
      if (this.$store.state.role === 'guest') {
        this.toggleBlock(false);
      }
    },
    guestRouteFilter(path) {
      const allowedForGuest = ['/platform', '/programs', '/platform/intGrants', '/platform/schools', '/platform/premium', '/platform/useful'];
      const blockedForGuest = ['/favourites', '/platform/admission'];
      if (this.$store.state.role === 'guest') {
        if (allowedForGuest.includes(path)) { this.toggleBlock(false); this.$router.push(path); }
        else if (blockedForGuest.includes(path)) { this.toggleBlock(true); }
        else { this.toggleBlock(true); }
      } else {
        this.toggleBlock(false);
        this.$router.push(path);
      }
    },
    async getPage() {
      try {
        const res = await axios.get('/V1/articles');
        this.news = res.data.data;
      } catch {}
    },
  },
  async created() {
    this.getPage();
  },
};
</script>

<style lang="scss" scoped>
/* ---------- sidebar shell (classic blue platform) ---------- */
.nsb {
  display: flex;
  flex-direction: column;
  width: clamp(288px, calc(20vw - 12px), 388px);
  min-width: clamp(288px, calc(20vw - 12px), 388px);
  height: 100%;
  padding: 10px min(max(18px, calc(1.125rem + ((1vw - 7.68px) * 1.0417))), 30px);
  background: transparent;
  overflow: hidden;
  transition: width 0.2s ease, min-width 0.2s ease, padding 0.2s ease;
  font-family: 'Manrope', sans-serif;
  box-sizing: border-box;

  &--collapsed {
    width: 72px;
    min-width: 72px;
    padding: 10px 12px;
  }
}

/* ---------- header ---------- */
.nsb__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0 0 8px;
  min-height: 48px;
  flex-shrink: 0;
  overflow: hidden;

  .nsb--collapsed & {
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
    padding: 0 0 10px;
  }
}

.nsb__logo {
  display: flex;
  align-items: center;
  text-decoration: none;
  overflow: hidden;

  img {
    width: 145px;
    height: 30px;
    object-fit: contain;
    display: block;
    flex-shrink: 0;
  }
}

.nsb__logo-mini {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #11415d;
  font-size: 20px;
  font-weight: 800;
  flex-shrink: 0;
  cursor: pointer;
}

.nsb__toggle-btn {
  border: 1px solid rgba(255, 255, 255, 0.28);
  background: rgba(255, 255, 255, 0.12);
  cursor: pointer;
  padding: 7px;
  border-radius: 8px;
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  flex-shrink: 0;
  transition: background 0.15s, border-color 0.15s, color 0.15s, transform 0.15s;

  &:hover {
    background: rgba(255, 255, 255, 0.22);
    border-color: rgba(255, 255, 255, 0.45);
    color: #fff;
    transform: translateY(-1px);
  }

  &--expand {
    width: 100%;
    min-height: 36px;
    padding: 8px 6px;
    flex-direction: column;
    gap: 4px;
  }
}

.nsb__toggle-label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  line-height: 1;
  color: rgba(255, 255, 255, 0.92);
}

/* ---------- middle: nav + news ---------- */
.nsb__body {
  flex: 1 1 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* ---------- nav (primary — never shrink when news loads) ---------- */
.nsb__nav {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 0 0 auto;
  flex-shrink: 0;
  padding: 16px 0 8px;
  overflow: visible;
}

.nsb__section-label {
  padding: 8px 0 6px;
  font-size: 12px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.54);
  letter-spacing: normal;
  white-space: nowrap;
  margin: 0;
  flex-shrink: 0;
}

/* ---------- nav item ---------- */
.nsb__item {
  display: flex;
  align-items: center;
  gap: min(max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.434))), 15px);
  padding: min(max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.434))), 15px);
  margin: 0;
  min-height: 44px;
  box-sizing: border-box;
  border-radius: 5px;
  cursor: pointer;
  transition: opacity 0.2s, background 0.15s, color 0.15s;
  color: #fff;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.35;
  white-space: nowrap;
  overflow: hidden;
  background: transparent;
  border: none;
  font-family: inherit;
  text-align: left;
  width: 100%;

  .nsb--collapsed & {
    justify-content: center;
    padding: 12px 0;
    min-height: 44px;
    gap: 0;
  }

  &:hover {
    opacity: 0.75;
  }

  &--active {
    background: #fff;
    color: #11415d !important;
    opacity: 1;

    &:hover {
      opacity: 1;
    }

    .nsb__item-icon {
      filter: brightness(0) saturate(100%) invert(18%) sepia(12%) saturate(7315%) hue-rotate(175deg) brightness(90%) contrast(87%) !important;
    }
  }

  &--active-curator {
    background: #fff;
    color: #fd2d2a !important;
    opacity: 1;

    .nsb__item-icon {
      filter: brightness(0) saturate(100%) invert(43%) sepia(76%) saturate(3165%) hue-rotate(336deg) brightness(90%) contrast(122%) !important;
    }
  }

  &--active-visor {
    background: #fff;
    color: #2bc38e !important;
    opacity: 1;

    &:hover {
      opacity: 1;
    }

    .nsb__item-icon {
      filter: brightness(0) saturate(100%) invert(61%) sepia(67%) saturate(476%) hue-rotate(108deg) brightness(93%) contrast(82%) !important;
    }
  }
}

.nsb__item-icon {
  width: 14px;
  height: 14px;
  object-fit: contain;
  flex-shrink: 0;
  filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7500%) hue-rotate(117deg) brightness(99%) contrast(100%);
  transition: filter 0.12s;
}

/**
 * Значок непрочитанного.
 *
 * Развёрнутое меню — число справа; свёрнутое — точка на иконке: число рядом с
 * одним значком не прочитать, а знать «что-то пришло» нужно и там.
 */
.nsb__badge {
  flex: none;
  margin-left: auto;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: #ff8800;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;

  &--dot {
    position: absolute;
    top: 8px;
    right: 12px;
    min-width: 9px;
    width: 9px;
    height: 9px;
    padding: 0;
    margin: 0;
  }
}

.nsb__item {
  position: relative;
}

.nsb__item-label {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ---------- news (fills remaining sidebar height) ---------- */
.nsb__news {
  flex: 1 1 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 8px 0 0;
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.35) transparent;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.35);
    border-radius: 4px;
  }

  .nsb__section-label {
    padding-top: 4px;
    flex-shrink: 0;
  }
}

.nsb__news-item {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px;
  font-size: 12px;
  color: #fff;
  text-decoration: none;
  transition: opacity 0.15s;
  cursor: pointer;
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  flex-shrink: 0;

  &:hover {
    opacity: 0.85;
  }

  img {
    width: 100%;
    aspect-ratio: 16 / 9;
    object-fit: cover;
    border-radius: 8px;
  }

  span {
    font-weight: 400;
    line-height: 1.4;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}
</style>
